import { encodeToJWTToken } from "./../utils/encodeJWTReq";
import axios from "axios";

const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://mescvapi.dev.dctinc.net",
});

apiInstance.interceptors.request.use(
  function (config) {
    if (config.method !== "get" && config.data) {
      const payload = config.data;
      if (config?.url === "/auth/logout") {
        config.data = payload;
      } else {
        const token = encodeToJWTToken(payload);
        config.data = { data: token };
      }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default apiInstance;
